import pL from 'js-regex-pl';

export type ValidationError = {
  field: string,
  message: string,
};

export default class Validator {
  constructor(rules) {
    this.rules = rules;
  }

  validate(data, rules = this.rules) {
    const errors = [];

    const rulesEntries = Object.entries(rules);

    for (let i = 0; i < rulesEntries.length; i++) {
      const [field, matchers] = rulesEntries[i];
      const value = data[field];

      for (let j = 0; j < matchers.length; j++) {
        const match = matchers[j];
        const error = match(value, data);

        if (error) {
          errors.push({
            field,
            message: error,
          });

          break;
        }
      }
    }

    /*  REPLACED WITH THE UPPER CYCLE TO AVOID IE COMPATIBILITY ISSUES
        PROBABLY THIS ISSUE SHOULD BE SOLVED USING THE CORRESPONDING POLYFILL  */

    // for (const [field, matchers] of Object.entries(rules)) {
    //   const value = data[field];
    //
    //   for (const match of matchers) {
    //     const error = match(value, data);
    //
    //     if (error) {
    //       errors.push({
    //         field,
    //         message: error,
    //       });
    //
    //       break;
    //     }
    //   }
    // }

    return errors;
  }

  static required = value => !value && 'This field is required';

  static email = value => {
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return !regex.test(value.toLowerCase()) && 'Please type your email address in the format yourname@examle.com';
  };

  static min = length => value =>
    !(typeof value === 'string' && value.length >= length) && `Use at least ${length} characters`;

  static max = length => value =>
    !(typeof value === 'string' && value.length <= length) && `Field must be at max ${length} chars long`;

  static same = field => (value, data) => !(data[field] === value) && "These passwords don't match";
  // return !(data[field] === value) && `Field must be the same as "${field}"`;

  static minmax = (min, max) => {
    const checkMin = Validator.min(min);
    const checkMax = Validator.max(max);

    return value => checkMin(value) || checkMax(value);
  };

  static size = length => value =>
    !(typeof value === 'string' && value.length === length) && `Field must be of ${length} chars length`;

  static numeric = value => !/^\d+$/.test(value) && 'This field accepts only numbers';

  static alphabetic = value => !new RegExp(`^[${pL} \-'"]+$`).test(value) && 'Must contain only alphabetic characters';

  static noForbiddenSigns = value => /[<>[\]\{}$]/.test(value) && 'Signs {} <> [] $ are not allowed';

  static date = value => {
    const date = new Date();
    const currentYear = date.getFullYear();
    const currentMonth = date.getMonth() + 1;
    const year = `20${value.substring(3)}`;
    const month = value.substring(0, 2);

    if (year < currentYear || (month < currentMonth && year === currentYear)) {
      return 'Invalid date';
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/Validation/Validator.js